import { Directive, Input } from '@angular/core';
import { AbstractControl, ControlContainer, FormControl } from '@angular/forms';
import { NdmsSafeSubscriber } from 'projects/shared/core/interfaces/ndms-safe-subscriber';

@Directive()
export abstract class BaseUiFormControl extends NdmsSafeSubscriber {
  @Input() formControl: FormControl;
  @Input() formControlName: string;
  @Input() cssClass: string = 'form-control';
  @Input() label: string = '';
  @Input() focus: boolean = false;
  @Input() readOnly?: boolean;
  @Input() errorMessages: any = {};
  @Input() isReadOnly?: boolean;
  
  constructor(
    protected controlContainer: ControlContainer) {
    super();
  }

  get control() {
    return this.formControl || this.controlContainer.control.get(this.formControlName);
  }

  get validator() {
    if (this.control) {
      let abstractControl: AbstractControl = this.control;
      if (abstractControl.validator) {
        return abstractControl.validator({} as AbstractControl) || {};
      }
    }
    return {};
  }
  
}
